import React from 'react';
import { useT } from '@repo/common';
import RichText from './RichText';

const JobDescription = ({ job }) => {
  const t = useT();
  const content = job?.detailInfo?.trim() || '-';

  return (
    <div>
      <div className='flex flex-col items-start py-[30px] w-full gap-2 tabletH:gap-4 text-text-primary '>
        <div className='typo-b18Strong self-stretch'>
          {t('Job description', '상세 업무 내용')}
        </div>
        <RichText text={content} />
      </div>

      <div className='border-b border-grayscale-gray02' />
    </div>
  );
};

export default JobDescription;
